import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { Apify, ApifyFullScreenLoadingComponent } from '../Apify';
import { StockCard } from '../c/ChartCard';
import { T } from '../traks';

import SearchField from '../c/SearchField';
import { StockExploreCard } from './Explore.js';

const G = (props) => props.children;

var ExploreHEL = (props) => {
	var sections = [];

	sections.push(
		<Row key="vntjcgfBiuRGMj0i" className="align-items-center">
			<Col xs="12" className="pb-3">
				<h3 className="pt-5"><T>Finnish collections</T></h3>
			</Col>
			<StockExploreCard ticker="OMXH25" exchange="IDX-HEL" card_img="/gfx/omxh25-350x136-0.svg" name="OMXH25" href="/portfolio/9880"/>
			<Col xs="12" className="pb-3">
				<h3><T>Selected Finnish stocks</T></h3>
			</Col>
			<StockExploreCard ticker="NOKIA" exchange="HEL" card_img="/gfx/nokia-350x136-0.svg" name="Nokia" href="/ticker/HEL/NOKIA"/>
			<StockExploreCard ticker="TELIA1" exchange="HEL" card_img="/gfx/telia-350x136-0.svg" name="Telia" href="/ticker/HEL/TELIA1"/>
			<StockExploreCard ticker="NRE1V" exchange="HEL" card_img="/gfx/nokiantyres-350x136-0.svg" name="Nokian Tyres" href="/ticker/HEL/NRE1V"/>
			<StockExploreCard ticker="KNEBV" exchange="HEL" card_img="/gfx/koneelevator-350x136-0.svg" name="KONE Corporation" href="/ticker/HEL/KNEBV"/>
			<StockExploreCard ticker="FIA1S" exchange="HEL" card_img="/gfx/finnair-350x136-0.svg" name="Finnair" href="/ticker/HEL/FIA1S"/>
			<StockExploreCard ticker="FSKRS" exchange="HEL" card_img="/gfx/fiskars-350x136-0.svg" name="Fiskars" href="/ticker/HEL/FSKRS"/>
		</Row>

	);

	for (const section of props.home.Sections) {
		var items = [];

		const mk_stock_item = (asset) => {
			const key = `STOCK:${asset.Exchange}:${asset.Ticker}`;
			return (
				<Col key={key} md="3" className="pb-4">
					<StockCard
						exchange={asset.Exchange}
						ticker={asset.Ticker}
						range="3m"
					/>
				</Col>
			);
		};

		switch (section.Type) {
			case "STOCKS":
				items = section.Content.map(mk_stock_item);
				break;
			default:
				continue;
		}
		sections.push(
				<span key="SPANNING_ALL">
				<Row key={section.Type}>
					<Col xs="12" className="pb-3">
						<h3><T>Random Finnish stocks</T></h3>
					</Col>
				</Row>
				<Row>
					{items}
				</Row>
				</span>
		);
	}

	const placeholder = <T>Search Finnish assets</T>;

	return (
		<G>
			<div className="d-flex flex-column text-center ad_explore_large_img_hel justify-content-center">
				<div className="pt-5 text-white ad_explore_txt_header"><T>Finland</T></div>
				<div className="text-white pb-3 ad_explore_txt_subheader px-2"><T>Explore assets exclusively from Finland</T></div>
				<SearchField placeholder={placeholder} market="FI_STOCK" form_classes="justify-content-center pt-2" input_classes="ad_search_explore_page ad_no_outline_focus" input_id="search_field_1"/>
			</div>
			<Container>
				{sections}
			</Container>
		</G>
	);
}

ExploreHEL = Apify("/z/explore?market=FI_STOCK")
	.with_response_prop("home")
	.wrap(ExploreHEL, ApifyFullScreenLoadingComponent);

export default ExploreHEL;



// WEBPACK FOOTER //
// ./src/p/ExploreHEL.js